<div class="waiting">
  <h2>Connection error. If the problem persists, please contact the administrator</h2>
  <button class="btn btn-warning" (click)="returnCpq()">Return to CPQ</button>
</div>
